var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex",on:{"click":_vm.toDownLoadPage}},[_c('img',{staticClass:"flex0",attrs:{"src":_vm.$icons.file,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"ml10 content flex0 pr10"},[_c('h3',{staticClass:"lines2"},[_vm._v(_vm._s(_vm.info.attaFileName))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-2dfe5151","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/plugins/consult/file-section.vue
// module id = 1331
// module chunks = 382